// export class Seva {
//     id: number;
//     sevaname : string;
//     //sevacategory : number; //TDB
//     sevacategory : string; 
//     sevaamount : number;
//     personsincluded : number;
//     itemlist : string;
//     checked:boolean;
// }

export class Seva {
    id: number;
    sevaname : string;
    //sevacategory : number; //TDB
    sevacategory : any; 
    sevaamount : number;
    persons_included : number;
    itemlist : string;
    tokencolor:string;
    counter_booking_limit?:number;
    online_booking_limit?:number;
    is_active?:number;
    // maasa?:Maasa[];
    maasa?:any;
    maasa_data?:any;
    // nakshatra?:Nakshatra[];
    nakshatra?:any;
    nakshatra_data?:any;
    // paksha?:Paksha[];
    paksha?:any;
    paksha_data?:any;
    // tithi?:Tithi[];
    tithi?:any;
    tithi_data?:any;
    sevacategory_data:any;

    weekdays?:number;
    //categories?:any;
persons?:any; //now I changed to persons before it was personsincluded
amount?:any;
   

     

    checked:boolean = false; //for local usage
}
export class Maasa
{
    id:number;
    name:string;
}
export class Nakshatra
{
    id:number;
    name:string;
}
export class Paksha
{
    id:number;
    name:string;
}
export class Tithi
{
    id:number;
    name:string;
}



// WEBPACK FOOTER //
// ./src/models/Seva.ts